export const RouteName = Object.freeze({
  changePassword: '/change-password',
  resetpassword: '/reset-password',
  splitHome: '/splitHome/confirmation',
  splitHomeSelection: '/splitHome/selection',
  register: '/register',
  registerOne: '/en*',
  registerTwo: '/it*',
  registerThree: '/es*',
  registerFour: '/ca*',
  registerFive: '/de*',
  registerSix: '/ro*',
});
